import React from "react";
import { FiZap, FiTrendingUp, FiGlobe } from "react-icons/fi";
import "../../styles/challenges.css";

export default function PublicInnovation() {
  return (
    <div className="challenges-container">
      <section className="challenge-hero">
        <div className="challenge-hero-content">
          <h1>Public Innovation Challenge</h1>
          <p className="challenge-subtitle">Innovation for Social Good</p>
        </div>
      </section>

      <section className="challenge-content">
        <div className="content-wrapper">
          <div className="challenge-section">
            <div className="section-header-v2">
              <span className="accent-line"></span>
              <h3>About the Challenge</h3>
            </div>
            <p>
              The Public Innovation Challenge welcomes forward-thinking innovators and entrepreneurs to develop 
              solutions that address pressing public sector challenges. This initiative aims to foster partnerships 
              between the private sector, academia, and government to drive meaningful social and economic impact.
            </p>
          </div>

          <div className="challenge-section">
            <div className="section-header-v2">
              <span className="accent-line"></span>
              <h3>Challenge Areas</h3>
            </div>
            <div className="features-grid">
              <div className="feature-card">
                <FiZap className="feature-icon" />
                <h3>Digital Transformation</h3>
                <p>Modernizing public services through technology</p>
              </div>
              <div className="feature-card">
                <FiTrendingUp className="feature-icon" />
                <h3>Economic Growth</h3>
                <p>Creating sustainable economic opportunities</p>
              </div>
              <div className="feature-card">
                <FiGlobe className="feature-icon" />
                <h3>Social Impact</h3>
                <p>Solving critical community challenges</p>
              </div>
            </div>
          </div>

          <div className="challenge-section">
            <div className="section-header-v2">
              <span className="accent-line"></span>
              <h3>Participation Benefits</h3>
            </div>
            <ul className="benefits-list">
              <li>Direct access to government stakeholders and decision-makers</li>
              <li>Funding opportunities for winning solutions</li>
              <li>Implementation support from IAMAR network</li>
              <li>Media coverage and public visibility</li>
              <li>Partnership development with key institutions</li>
            </ul>
          </div>

          <div className="challenge-section cta-section">
            <button className="cta-button">Submit Your Innovation</button>
          </div>
        </div>
      </section>
    </div>
  );
}
